import React from 'react';
import "../App.css";
const Footer = () => {
  return (
    <div className='foot'>
        <br/>
        <h1 className='h1f'>Footer</h1>
    </div>
  )
}

export default Footer;